module.exports = __webpack_public_path__ + "static/media/2DGACM8.8292ddd4.jpg";